
import missions from '~/mixins/pages/mission-control/missions'
export default {
    name: 'Theme2MissionDesktopDailyActivityMissionClaimBox',
    mixins: [missions],
    props: {
        missionDate: {
            type: String,
            default: '',
        },
        activityStatus: {
            type: Number,
            default: 1,
        },
        activityImg: {
            type: String,
            default: '',
        },
        activityName: {
            type: String,
            default: '',
        },
        activityDescription: {
            type: String,
            default: '',
        },
        activityRewardAmount: {
            type: Number,
            default: 0,
        },
        activityId: {
            type: String,
            default: '',
        },
        missionId: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isExtraCoin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            displaySuccessClaimDialog: false,
            displayActivityDetailDialog: false,
            selectedItem: {},
            claimLoading: false,
        }
    },
    methods: {
        async onClaimActivity() {
            if (this.activityStatus === 1 || this.activityStatus === 3) {
                return
            }
            let claimActivity = 'activities/mission-reward/claimActivity'
            let claimParams = {
                activity_id: this.activityId,
                mission_id: this.missionId,
            }
            if (this.isExtraCoin) {
                claimActivity = 'activities/mission-reward/onClaimExtraCoin'
                claimParams = this.missionId
            }
            this.claimLoading = true
            const response = await this.$store.dispatch(
                claimActivity,
                claimParams
            )
            if (response) {
                // To get notifications
                this.$store.dispatch('activities/notification/getNotifications')
                this.$store.dispatch('player/totalBalance')
                // Fetch the new updated mission detail
                await this.fetchMissionDetail()
                this.displaySuccessClaimDialog = true
                setTimeout(() => {
                    this.displaySuccessClaimDialog = false
                }, 1500)
            }
            this.claimLoading = false
        },
        onDisplayActivityDetail() {
            this.displayActivityDetailDialog = true
        },
        async fetchMissionDetail() {
            await this.$store.dispatch(
                'activities/mission-reward/getMissionById',
                this.$route.query.mission_id
            )
        },
    },
}
